import { render, staticRenderFns } from "./PortalPageTitle.vue?vue&type=template&id=0437f35a&"
import script from "./PortalPageTitle.vue?vue&type=script&lang=js&"
export * from "./PortalPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports